//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {Toast } from 'mint-ui';
  import {
    BASIC
  } from "@/config/constant"
  import promise from '@/axios/promise'
  export default {
    name: 'modifyPwd',
    data() {
      return {
        validateForm: {
          password: '',
          newPwd: '',
          confirmPwd: ''
        },
        pwdRules: [{
         
            validate: (val) => !!val,
            message: '请输入密码'
          }
        ],
        newPwdRules: [{
            validate: (val) => !!val,
            message: '请输入新密码'
          }
        ],
        confirmRules: [{
            validate: (val) => !!val,
            message: '请再次输入密码'
          },
          {
            validate: (val) => this.validateForm.newPwd == this.validateForm.confirmPwd,
            message: '两次输入密码不一致'
          }
        ],
      }
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      comfirm() {
        var ddd=  this.$refs.form.validate();
        this.$refs.form.validate().then((result) => {
          if(!result){
            var password=this.validateForm.password;
            var newPwd=this.validateForm.newPwd;
            var confirmPwd=this.validateForm.confirmPwd;

            if(password==null || password==""){
               Toast({  message: '请输入密码!', duration: 1500,position: 'middle', className:"warning" });
                return;
            }
            if(newPwd==null || newPwd==""){
             Toast({  message: '请输入新密码!', duration: 1500,position: 'middle', className:"warning" });
               return;
            }
            if(confirmPwd==null || confirmPwd==""){
                Toast({  message: '请再次输入密码!', duration: 1500,position: 'middle', className:"warning" });
                 return;
            }
            if(newPwd!=confirmPwd){
                Toast({  message: '两次输入密码不一致!', duration: 1500,position: 'middle', className:"warning" });
                 return;
            }
            return;
          }
          promise({
            method: 'put',
            params: {
              pwd: this.validateForm.password,
              newPwd: this.validateForm.newPwd
            },
            url: BASIC + '/user/pwd/modify'
          }).then(res => {
            if(res.code==0){
                Toast({  message: '操作成功!', duration: 1500,position: 'middle', className:"success" });
            }else{
                Toast({  message: res.msg, duration: 1500,position: 'middle', className:"warning" });
             }
          });
        });
      }
    }
  }



// WEBPACK FOOTER //
// ./src/view/index/mine/modify_pwd.vue